import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_OrderController_SaveStatus_Input_Value,
  useOrderSaveStatusMutation,
} from 'api/generated/graphql';
import { parseOrderEntity, useError } from 'api/helpers';
import { OrderStatusType } from 'api/types/entity/order/orderStatusType';

interface OrderSaveStatusParams {
  value: OrderStatusType;
  reason?: string;
  fmNumber?: string;
  closedDate?: string;
}

export const useOrderSaveStatus = () => {
  const [saveStatus, { loading, error: apolloError }] =
    useOrderSaveStatusMutation();

  const error = useError(apolloError);

  return {
    saveStatus: useCallback(
      async (
        id: string,
        versionNumber: number,
        params: OrderSaveStatusParams
      ) => {
        const res = await saveStatus({
          variables: {
            id,
            input: {
              versionNumber,
              value:
                MutationInput_OrderController_SaveStatus_Input_Value[
                  params.value
                ],
              reason: params.reason || undefined,
              fmNumber: params.fmNumber || undefined,
              closedDate: params.closedDate || undefined,
            },
          },
        });
        return res.data?.saveStatus
          ? parseOrderEntity(res.data?.saveStatus)
          : null;
      },
      [saveStatus]
    ),
    loading,
    error,
  };
};
